import React, { useState } from 'react'
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons'

export default function PasswordField({ defaultValue, onChange }) {
    const [showPW, setShowPW] = useState(false)
    return (
        <div className='d-flex position-relative'>
            <input
                defaultValue={defaultValue} onChange={onChange}
                type={showPW ? "text" : "password"} className="wizard-input form-control"
                placeholder="Password" />
            <button className='btn position-absolute' style={{ zIndex: 2, right: '0px' }} onClick={() => setShowPW(!showPW)}>
                {showPW ? <EyeSlashFill /> : <EyeFill />}
            </button>
        </div>
    )
}
